import { Component,HostListener, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SearchFieldsComponent } from '../../../modules/fileviewer/pages/search-fields/search-fields.component'

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css']
})


export class ControlComponent implements OnInit {
  islistRTN:Boolean =false;
  islistChemical:Boolean =false;
  chemicalValidationShow=false;
  options: string[] = ['One', 'Two', 'Three'];
  @Input() property: any = null as any;
  @Input() form: FormGroup;
  @Input() index: number;
  @Input() formSubmit: boolean;
  @Output() openModal = new EventEmitter();
  formGroup: FormGroup;
  get isValid() {
    if (this.property.type !== 'button' || this.property.type !== 'hidden')
      return this.form.controls[this.property.key].invalid && (this.formSubmit || this.form.controls[this.property.key].dirty || this.form.controls[this.property.key].touched)

  }

  @HostListener("click") 
  clicked() { 
    this.islistChemical=false 
  } 

  /*isItFormControl(group: FormGroup | FormArray): AbstractControl {
   var abstractControl : AbstractControl;
     Object.keys(group.controls).forEach((key: string) => {
       abstractControl = group.controls[key];

       if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
           this.isItFormControl(abstractControl);
       } 
   });
   return abstractControl;
 }*/
  get getErrors() {
    return this.form.controls[this.property.key]?.errors;
  }
  constructor(private fb: FormBuilder, private searchField: SearchFieldsComponent) { }
  ngOnInit() { }
  private asFormArray(ctrl: AbstractControl): FormArray {
    return ctrl as FormArray;
  }
  checkNumberandLength(event, maxLength, isNumberOnly) {
    if (isNumberOnly) {
      if (this.onlyNumberKey(event)) {
        if (event.target.value.length >= maxLength)
          event.preventDefault();
      }
      else {
        event.preventDefault();
      }
    }

  }
  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  DateFieldKeyDown(event) {
    if (event.key == 'Tab') {
      return true;
    }
    else
      event.preventDefault();
  }
  public get propertyIsIterable(): boolean {
    return !!this.property && this.property.iterable;
  }
  public propertyControl(index: number): FormControl {
    if ((this.propertyIsIterable && !this.property.modal))
      return this.asFormArray(this.form.controls[this.property.key]).controls[index] as FormControl;
    else
      return this.form.get(this.property.key) as FormControl;
  }
  public propertyId(index?: number): string {
    return (this.propertyIsIterable && !this.property.modal) ? this.property.items[index].key : this.property.key;
  }
  public propertyControlType(): string {
    return this.property.controlType;
  }
  public propertyLabel(index?: number): string {
    return (this.propertyIsIterable && !this.property.modal) ? this.property.items[index].label : this.property.label;
  }
  buttonClick() {
    this.openModal.emit(this.property.key);
  }

  cityDropdownChanges() {
    this.searchField.cityChanges();
  }

  enteredRTN(event) {
    debugger;
    if(event.target.value.length <9)
    {
      this.islistRTN=true
      this.searchField.searchRTN(event.target.value);
    }
    else{
      this.islistRTN=false
      this.searchField.searchRTN(event.target.value);
    }
    
  }

  selectRTNItem(item: any)
  {
    debugger;
    this.islistRTN=false
    this.searchField.assignSelectedRTN(item);
  }

  enteredChemical(event) {
    debugger;
    if(event.target.value.length>2)
    {
      this.chemicalValidationShow=false;
      this.islistChemical=true
      this.searchField.searchChemical(event.target.value);
    }
    else{
      this.chemicalValidationShow=true;
      this.islistChemical=false
      this.searchField.searchChemical(event.target.value);
    }
    
  }

  selectChemicalItem(item: any)
  {
    debugger;
    this.islistChemical=false
    this.searchField.assignSelectedChemical(item);
  }


}
